import { useEffect, useMemo, useState } from "react";
import { filterObjectByKeys, disabledFilterTooltipTitle } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { programLevelFriendlyMap } from "@portal/app/_common/data/enumValueMaps";
import pick from "lodash/pick";
import { EnumMultiSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import isEmpty from "lodash/isEmpty";
import { FilterComponentProps } from "./DreamSearchFilter";

export const ProgramLevelFilterComponent = ({
  value,
  setValue,
  setHasOptions,
}: FilterComponentProps<GQL.ProgramLevel[]>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<GQL.ProgramLevel[]>(value);
  // Filter out the program levels that are not in the filter settings
  // and then sort them to match the order in the friendly map.
  const [availableOptions] = useState(
    pick(
      filterObjectByKeys(programLevelFriendlyMap, filterSettings?.programLevel),
      Object.keys(programLevelFriendlyMap)
    )
  );
  const debounceSetValue = useMemo(
    () => debounce((localValue: GQL.ProgramLevel[]) => setValue(localValue), 500),
    [setValue]
  );

  useEffect(() => {
    if (filterSettings) {
      setHasOptions(Object.keys(availableOptions).length > 0);
    }
  }, [availableOptions, filterSettings, setHasOptions]);

  return (
    <EnumMultiSelectChipFilter<GQL.ProgramLevel>
      label="Program level"
      value={localValue}
      id="program-level"
      setValue={(value) => {
        const newValue = isEmpty(value) ? null : value;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
      disabledTooltipTitle={disabledFilterTooltipTitle}
    />
  );
};
